<template>
  <div id="dashboard">
      <div class="dashboard-card div1">
        <h2>Demnächst Abrechnen</h2>
        <div v-if="baustellen">
          <table class="button-table">
            <tr class="table-head">
              <th>Bauherr</th>
              <th>Bauvorhaben</th>
              <th>Rechnungsdatum</th>
              <th>Details</th>
            </tr>
            <tr v-for="zp in nextORg" :key="zp.idx">
              <td scope="row">{{ zp.bauherr }}</td>
              <td scope="row">{{ zp.adresse }}</td>
              <td scope="row">{{ zp.datum | formatDate }}</td>
              <td class="button-col"><router-link class="button arrow-button" :to="{ name: 'Detail', params: { id: zp.id }}"><span class="material-icons">arrow_forward</span></router-link></td>
            </tr>
          </table>
        </div>
      </div>

      <div class="dashboard-card div2">
        <div>
          <h2>Auftragsbestand</h2>
          <table class="summen-table">
            <tbody>
              <tr class="table-head">
                <th>Summe Aufträge brutto</th>
                <th>Summe bezahlt brutto</th>
                <th>Summe offen</th>
              </tr>
              <tr>
                <td>{{ (aufragssummen + (aufragssummen * 0.2 )).toLocaleString('de-DE', {minimumFractionDigits: 2}) }} €</td>
                <td>{{ bezahltSumme.toLocaleString('de-DE', {minimumFractionDigits: 2}) }} €</td>
                <td>{{ (aufragssummen + (aufragssummen * 0.2 ) - bezahltSumme).toLocaleString('de-DE', {minimumFractionDigits: 2}) }} €</td>
              </tr>
            </tbody>
          </table>
          <br>
          <table class="summen-table">
            <tbody>
              <tr class="table-head">
                <th>Summe Aufträge netto</th>
                <th>Summe verrechnet netto</th>
                <th>Summe offen</th>
              </tr>
              <tr>
                <td>{{ aufragssummen.toLocaleString('de-DE', {minimumFractionDigits: 2}) }} €</td>
                <td>{{ verrechnetSumme.toLocaleString('de-DE', {minimumFractionDigits: 2}) }} €</td>
                <td>{{ (aufragssummen - verrechnetSumme).toLocaleString('de-DE', {minimumFractionDigits: 2}) }} €</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="dashboard-card div3">
        <h2>To Do</h2>
        <div v-if="toDo">
          <table class="button-table">
            <tr class="table-head">
              <th style="width: 400px;">Adresse</th>
              <th style="width: 500px;">Bauvorhaben</th>
              <th>Beginn</th>
              <th>VA</th>
              <th>Pläne</th>
              <th>Firmen</th>
              <th>BZP</th>
              <th>SiGe</th>
              <th>Details</th>
            </tr>
            <tr v-for="(bst, index) in toDo.slice(toDoCurrent, toDoNext)" :key="index" :style="{ background: bst.color}">
              <td scope="row">{{ bst.adresse }}</td>
              <td scope="row">{{ bst.bvh }}</td>
              <td scope="row">{{ bst.beginn | formatDate }}</td>
              <td scope="row" style="text-align: center">
                <div v-if="bst.vorankuendigung"><span class="material-icons">done</span></div>
                <div v-else><span class="material-icons">close</span></div>
              </td>
              <td scope="row" style="text-align: center">
                <div v-if="bst.plaene"><span class="material-icons">done</span></div>
                <div v-else><span class="material-icons">close</span></div>
              </td>
              <td scope="row" style="text-align: center">
                <div v-if="bst.firmen"><span class="material-icons">done</span></div>
                <div v-else><span class="material-icons">close</span></div>
              </td>
              <td scope="row" style="text-align: center">
                 <div v-if="bst.bzp"><span class="material-icons">done</span></div>
                <div v-else><span class="material-icons">close</span></div>
              </td>
              <td scope="row" style="text-align: center">
                 <div v-if="bst.sige"><span class="material-icons">done</span></div>
                <div v-else><span class="material-icons">close</span></div>
              </td>
              <td class="button-col"><router-link class="button arrow-button" :to="{ name: 'Detail', params: { id: bst.id }}"><span class="material-icons">arrow_forward</span></router-link></td>
            </tr>
          </table>
        </div>
        <div v-else>
          Keine To-Dos &#9786;
        </div>
        <div class="center-button-row">
          <button class="button arrow-button" style="margin-right: 5px" v-if="toDoCurrent > 0" @click="toDoNext -= 8, toDoCurrent -= 8">
            <span class="material-icons">keyboard_arrow_left</span>
          </button>
          <button class="button arrow-button disabled" style="margin-right: 5px;" v-else>
            <span class="material-icons">keyboard_arrow_left</span>
          </button>
          <button class="button arrow-button" v-if="toDoNext <= toDo.length && toDo.length > toDoNext" @click="toDoNext += 8, toDoCurrent += 8">
            <span class="material-icons">keyboard_arrow_right</span>
          </button>
          <button class="button arrow-button disabled" style="margin-right: 5px;" v-else>
            <span class="material-icons">keyboard_arrow_right</span>
          </button>
        </div>
      </div>

      <div class="dashboard-card div3a">
        <h2>To Do Ende</h2>
        <div v-if="toDo">
          <table class="button-table">
            <tr class="table-head">
              <th style="width: 400px;">Adresse</th>
              <th style="width: 500px;">Bauvorhaben</th>
              <th>Ende</th>
              <th>ULfspA</th>
              <th>Details</th>
            </tr>
            <tr v-for="(bst, index) in toDoEnde.slice(toDoEndeCurrent, toDoEndeNext)" :key="index" :style="{ background: bst.color}">
              <td scope="row">{{ bst.adresse }}</td>
              <td scope="row">{{ bst.bvh }}</td>
              <td scope="row">{{ bst.ende | formatDate }}</td>
              <td scope="row" style="text-align: center">
                <div v-if="bst.ufa"><span class="material-icons">done</span></div>
                <div v-else><span class="material-icons">close</span></div>
              </td>
              <td class="button-col"><router-link class="button arrow-button" :to="{ name: 'Detail', params: { id: bst.id }}"><span class="material-icons">arrow_forward</span></router-link></td>
            </tr>
          </table>
        </div>
        <div v-else>
          Keine To-Dos &#9786;
        </div>
        <div class="center-button-row">
          <button class="button arrow-button" style="margin-right: 5px" v-if="toDoEndeCurrent > 0" @click="toDoEndeNext -= 8, toDoEndeCurrent -= 8">
            <span class="material-icons">keyboard_arrow_left</span>
          </button>
          <button class="button arrow-button disabled" style="margin-right: 5px;" v-else>
            <span class="material-icons">keyboard_arrow_left</span>
          </button>
          <button class="button arrow-button" v-if="toDoEndeNext <= toDoEnde.length && toDoEnde.length > toDoEndeNext" @click="toDoEndeNext += 8, toDoEndeCurrent += 8">
            <span class="material-icons">keyboard_arrow_right</span>
          </button>
          <button class="button arrow-button disabled" style="margin-right: 5px;" v-else>
            <span class="material-icons">keyboard_arrow_right</span>
          </button>
        </div>
      </div>

      <div class="dashboard-card chart div4" v-if="bstPlusArchiv.length && sumPerYear" >
        <h2>Auftragsbestand aktuell und Folgejahre (Rechnungssummen netto)</h2>
        <Piechart :sums="sumPerYear" :key="bstPlusArchiv.length" />
      </div>

      <div class="dashboard-card chart div5" v-if="bstPlusArchiv.length && sumMonth.length && sumUnBez.length">
        <div class="button-row">
          <h2>Umsatz / Verrechnung pro Monat {{ year + yearcount }}</h2>
          <div class="prev-next-btns">
            <button class="button arrow-button" style="margin-right: 5px"  v-if="year + yearcount > minYear" @click="yearcount -= 1">
              <span class="material-icons">keyboard_arrow_left</span>
            </button>
            <button class="button arrow-button disabled" style="margin-right: 5px;" v-else>
              <span class="material-icons">keyboard_arrow_left</span>
            </button>
            <button class="button arrow-button" v-if="year + yearcount < maxYear" @click="yearcount += 1">
              <span class="material-icons">keyboard_arrow_right</span>
            </button>
            <button class="button arrow-button disabled" v-else>
              <span class="material-icons">keyboard_arrow_right</span>
            </button>
          </div>
        </div>
        <RgChart :sumVerr="sumVerr" :sumUnBez="sumUnBez" :sumMonth="sumMonth" :sumBez="sumBez" :key='bstPlusArchiv.length && sumMonth.length && sumUnBez.length'/>
      </div>

      <div class="dashboard-card chart div5" v-else>
        <div class="button-row">
          <h2>Umsatz / Verrechnung pro Monat {{ year + yearcount }}</h2>
          <div class="prev-next-btns">
            <button class="button arrow-button" style="margin-right: 5px"  v-if="year + yearcount > minYear" @click="yearcount -= 1">
              <span class="material-icons">keyboard_arrow_left</span>
            </button>
            <button class="button arrow-button disabled" style="margin-right: 5px;" v-else>
              <span class="material-icons">keyboard_arrow_left</span>
            </button>
            <button class="button arrow-button" v-if="year + yearcount < maxYear" @click="yearcount += 1">
              <span class="material-icons">keyboard_arrow_right</span>
            </button>
            <button class="button arrow-button disabled" v-else>
              <span class="material-icons">keyboard_arrow_right</span>
            </button>
          </div>
        </div>
        <div>Keine Daten für {{ year + yearcount }} vorhanden.</div>
      </div>

      <div class="dashboard-card chart div6" v-if="bstPlusArchiv.length && sums.length && unbezahlt.length && verrOffen.length">
        <div class="button-row">
          <h2>Rechnungen {{ year + yearcount }}</h2>
          <div>
              <button class="button arrow-button" style="margin-right: 5px"  v-if="year + yearcount > minYear" @click="yearcount -= 1">
                <span class="material-icons">keyboard_arrow_left</span>
              </button>
              <button class="button arrow-button disabled" style="margin-right: 5px;" v-else>
                <span class="material-icons">keyboard_arrow_left</span>
              </button>
              <button class="button arrow-button" v-if="year + yearcount < maxYear" @click="yearcount += 1">
                <span class="material-icons">keyboard_arrow_right</span>
              </button>
              <button class="button arrow-button disabled" v-else>
                <span class="material-icons">keyboard_arrow_right</span>
              </button>
            </div>
          </div>
        <MonthChart :sums="sums" :unbezahlt="unbezahlt" :verrOffen="verrOffen" :key="yearcount" />
      </div>

      <div class="dashboard-card div7">
        <div class="button-row">
          <h2>Nicht abgerechnet {{ year + yearcount }}</h2>
          <div class="prev-next-btns">
            <button class="button arrow-button" style="margin-right: 5px"  v-if="year + yearcount > minYear" @click="yearcount -= 1">
              <span class="material-icons">keyboard_arrow_left</span>
            </button>
            <button class="button arrow-button disabled" style="margin-right: 5px;" v-else>
              <span class="material-icons">keyboard_arrow_left</span>
            </button>
            <button class="button arrow-button" v-if="year + yearcount < maxYear" @click="yearcount += 1">
              <span class="material-icons">keyboard_arrow_right</span>
            </button>
            <button class="button arrow-button disabled" v-else>
              <span class="material-icons">keyboard_arrow_right</span>
            </button>
          </div>
        </div>
        <table class="button-table" v-if="offeneRechnungen.length">
          <tr class="table-head">
            <th style="width: 400px;">Adresse</th>
            <th>Rechnungsbetrag</th>
            <th>Rechnungsdatum</th>
            <th>Details</th>
          </tr>
          <tr v-for="(rg, index) in offeneRechnungen.slice(offeneRechnungenCurrent, offeneRechnungenNext)" :key="index">
            <td scope="row">{{ rg.a }}</td>
            <td scope="row">{{ rg.y.toLocaleString('de-DE', {minimumFractionDigits: 2}) }} €</td>
            <td scope="row">{{ rg.x | formatDate }}</td>
            <td class="button-col">
              <router-link v-if="!rg.archiviert" class="button arrow-button" :to="{ name: 'Detail', params: { id: rg.id }}" target="_blank">
                <span class="material-icons">arrow_forward</span>
              </router-link>
              <router-link v-else class="button arrow-button archiv-btn" :to="{ name: 'Archivdetail', params: { id: rg.id }}" target="_blank">
                <span class="material-icons">arrow_forward</span>
              </router-link>
            </td>
          </tr>
        </table>
        <div v-else style="min-width: 500px;">Keine offenen Rechnungen für {{ year + yearcount }} vorhanden.</div>
        <div class="center-button-row">
          <button class="button arrow-button" style="margin-right: 5px" v-if="offeneRechnungenCurrent > 0" @click="offeneRechnungenNext -= 12, offeneRechnungenCurrent -= 12">
            <span class="material-icons">keyboard_arrow_left</span>
          </button>
          <button class="button arrow-button disabled" style="margin-right: 5px;" v-else>
            <span class="material-icons">keyboard_arrow_left</span>
          </button>
          <button class="button arrow-button" v-if="offeneRechnungenNext <= offeneRechnungen.length" @click="offeneRechnungenNext += 12, offeneRechnungenCurrent += 12">
            <span class="material-icons">keyboard_arrow_right</span>
          </button>
          <button class="button arrow-button disabled" style="margin-right: 5px;" v-else>
            <span class="material-icons">keyboard_arrow_right</span>
          </button>
        </div>
      </div>

     <!--  <div class="dashboard-card grow1" style="height: 1230px" v-if="lzAll.length">
        <h2 class="chart-heading">Leistungszeiträume</h2>
        <LzChart :lz="lzAll" style="height: 1200px; width: 800px;"/>
      </div> -->

      <div class="dashboard-card div8">
        <div>
          <h2>Baustellen</h2>
          <table>
            <tr class="table-head">
              <th>Aktuelle Baustellen</th>
              <th>{{baustellen.length}}</th>
            </tr>
          </table>
          <h2 style="margin-top: 20px">Auftraggeber</h2>
          <table>
            <tr class="table-head">
              <th>Auftraggeber</th>
              <th>Baustellen</th>
            </tr>
            <tr v-for="ag in auftraggeberList" :key="ag.idx">
              <td scope="row">{{ ag.ag }}</td>
              <td scope="row">{{ ag.count }}</td>
            </tr>  
          </table>
        </div>
      </div>

    
    <div class="dashboard-card div9">
      <div v-if="loading" @click="loadMap">
        <button class="button">Baustellenkarte laden</button>
      </div>
      <Map id="map" v-else :ads="ads"/>
    </div>

  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import Piechart from "./piechart";
import MonthChart from "./month-chart";
import RgChart from "./rg-chart";
import Map from "./map";
import axios from "axios";
import LzChart from "./lz-chart";

export default {
  components: {
    Piechart,
    MonthChart,
    RgChart,
    Map,
    //LzChart
  },
  data() {
    return {
      ads: [],
      loading: true,
      yearcount: 0,
      offeneRechnungenCurrent: 0,
      offeneRechnungenNext: 12,
      toDoCurrent: 0,
      toDoNext: 8,
      toDoEndeCurrent: 0,
      toDoEndeNext: 8
    };
  },
  computed: {
    ...mapState(["baustellen"]),
    ...mapGetters([
      "nextORg",
      "auftraggeberList",
      "bezahltSumme",
      "verrechnetSumme",
      "aufragssummen",
      "trsAbHeute",
      "bstPlusArchiv"
    ]),
    year: function() {
      return new Date().getFullYear();
    },
    toDo: function() {
      let vals = [];
      this.baustellen.forEach(el => {
        if ( !el.vorankuendigung || !el.sige ) {
          if (moment(el.beginn) < moment().add(6, "weeks") && moment(el.beginn) > moment("2022-01-01")) {
            let o = {};
            o.adresse = el.adresse
            o.bvh = el.bvh
            o.beginn = el.beginn 
            o.vorankuendigung = el.vorankuendigung
            o.ufa = el.ufa
            o.plaene = el.plaene
            o.firmen = el.firmen
            o.bzp = el.bzp
            o.sige = el.sige
            o.id = el.id
            vals.push(o) 
          }
        }
      })
      vals.sort((a, b) => { return new Date(a.beginn) - new Date(b.beginn) })
      vals.forEach(el => {
        if (moment(el.beginn).isBetween(moment(), moment().add(6, 'weeks'))) {
          el.color = "#84d7fa"
        }
        if (moment(el.beginn).isBetween(moment(), moment().add(4, 'weeks'))) {
          el.color = "#fac984"
        }
        if (moment(el.beginn) < moment().add(2, 'weeks')) {
          el.color = "#fa8484"
        }
      })
      return vals
    },
    toDoEnde() {
      let vals = [];
      this.baustellen.forEach(el => {
        if ( !el.ufa ) {
          if (moment(el.ende) < moment().add(6, 'weeks')) {
            let o = {};
            o.adresse = el.adresse
            o.bvh = el.bvh
            o.ende = el.ende
            o.vorankuendigung = el.vorankuendigung
            o.ufa = el.ufa
            o.plaene = el.plaene
            o.firmen = el.firmen
            o.bzp = el.bzp
            o.id = el.id
            vals.push(o) 
          }
        }
      })
      vals.sort((a, b) => { return new Date(a.ende) - new Date(b.ende) })
      vals.forEach(el => {
        if (moment(el.ende).isBetween(moment(), moment().add(6, 'weeks'))) {
          el.color = "#84d7fa"
        }
        if (moment(el.ende).isBetween(moment(), moment().add(4, 'weeks'))) {
          el.color = "#fac984"
        }
        if (moment(el.ende) < moment().add(2, 'weeks')) {
          el.color = "#fa8484"
        }
      })
      return vals
    },
    sums: function() {
      let vals = [];
      this.bstPlusArchiv.forEach(el => {
        el.zahlungsplan.forEach(zp => {
          if (zp.bezahlt && moment(zp.datum, 'YYYY-MM-DD').year() == this.year + this.yearcount) {
            let o = {};
            o.x = moment(zp.datum);
            o.y = zp.rechnungsbetrag
            o.a = el.adresse
            vals.push(o);
          }
        });
      });
      if (!vals.length) {
        vals.push(0)
      }
      return vals;
    },
    unbezahlt: function() {
      let vals = [];
      this.bstPlusArchiv.forEach(el => {
        el.zahlungsplan.forEach(zp => {
          if (!zp.bezahlt && moment(zp.datum, 'YYYY-MM-DD').year() == this.year + this.yearcount) {
            let o = {};
            o.x = moment(zp.datum);
            o.y = zp.rechnungsbetrag
            o.a = el.adresse
            vals.push(o);
          }
        });
      });
      if (!vals.length) {
        vals.push(0)
      }
      return vals;
    },
    offeneRechnungen: function() {
      let vals = [];
      this.bstPlusArchiv.forEach(el => {
        el.zahlungsplan.forEach(zp => {
          if (!zp.bezahlt && moment(zp.datum, 'YYYY-MM-DD').year() == this.year + this.yearcount) {
            let o = {};
            o.x = moment(zp.datum);
            o.y = zp.rechnungsbetrag
            o.a = el.adresse
            o.id = el.id
            o.archiviert = el.archiviert
            vals.push(o);
          }
        });
      });
      vals.sort((a,b) => {
        return a.x - b.x
      })
      return vals;
    },
    verrOffen: function() {
      let vals = [];
      this.bstPlusArchiv.forEach(el => {
        el.zahlungsplan.forEach(zp => {
          if (zp.verrechnet && !zp.bezahlt && moment(zp.datum, 'YYYY-MM-DD').year() == this.year + this.yearcount) {
            let o = {};
            o.x = moment(zp.datum);
            o.y = zp.rechnungsbetrag
            o.a = el.adresse
            vals.push(o);
          }
        });
      });
      if (!vals.length) {
        vals.push(0)
      }
      return vals;
    },
    sumMonth: function() {
      let vals = [];
      this.bstPlusArchiv.forEach(el => {
        el.zahlungsplan.forEach(zp => {
          if (
            zp.datum &&
            moment(zp.datum, 'YYYY-MM-DD').year() == this.year + this.yearcount &&
            zp.rechnungsbetrag
          ) {
            let o = {};
            o.x = moment(zp.datum, 'YYYY-MM-DD');
            o.y = zp.rechnungsbetrag;
            o.a = el.adresse
            vals.push(o);
          }
        });
      });
      let mapToMonth = vals.map(el => ({
        ...el,
        month: parseInt(moment(el.x).format('M'))
      }));
      
      let monthVals = mapToMonth.reduce((acc, cur) => {
        acc[cur.month] = acc[cur.month] + cur.y || cur.y;
        return acc;
      }, {});
      let sums = Object.entries(monthVals).map(([x, y]) => ({ x, y }));
      if (!sums.length) {
        sums.push(0)
      }
      return sums;
    },
    sumVerr: function() {
      let vals = [];
      this.bstPlusArchiv.forEach(el => {
        el.zahlungsplan.forEach(zp => {
          if (
            zp.verrechnet &&
            moment(zp.datum, 'YYYY-MM-DD').year() == this.year + this.yearcount &&
            zp.rechnungsbetrag
          ) {
            let o = {};
            o.x = moment(zp.datum, 'YYYY-MM-DD');
            o.y = zp.rechnungsbetrag;
            vals.push(o);
          }
        });
      });
      let mapToMonth = vals.map(el => ({
        ...el,
        month: parseInt(moment(el.x).format('M'))
      }));

      let monthVals = mapToMonth.reduce((acc, cur) => {
        acc[cur.month] = acc[cur.month] + cur.y || cur.y;
        return acc;
      }, {});
      let sums = Object.entries(monthVals).map(([x, y]) => ({ x, y }));
      if (!sums.length) {
        sums.push(0)
      }
      return sums;
    },
    sumBez: function() {
      let vals = [];
      this.bstPlusArchiv.forEach(el => {
        el.zahlungsplan.forEach(zp => {
          if (
            zp.bezahlt &&
            moment(zp.datum, 'YYYY-MM-DD').year() == this.year + this.yearcount &&
            zp.rechnungsbetrag
          ) {
            let o = {};
            o.x = moment(zp.datum, 'YYYY-MM-DD');
            o.y = zp.rechnungsbetrag;
            o.a = el.adresse
            vals.push(o);
          }
        });
      });
      let mapToMonth = vals.map(el => ({
        ...el,
        month: parseInt(moment(el.x).format('M'))
      }));

      let monthVals = mapToMonth.reduce((acc, cur) => {
        acc[cur.month] = acc[cur.month] + cur.y || cur.y;
        return acc;
      }, {});
      let sums = Object.entries(monthVals).map(([x, y]) => ({ x, y }));
      if (!sums.length) {
        sums.push(0)
      }
      return sums;
    },
    sumUnBez: function() {
      let vals = [];
      this.bstPlusArchiv.forEach(el => {
        el.zahlungsplan.forEach(zp => {
          if (
            !zp.bezahlt &&
            moment(zp.datum, 'YYYY-MM-DD').year() == this.year + this.yearcount &&
            zp.rechnungsbetrag
          ) {
            let o = {};
            o.x = moment(zp.datum, 'YYYY-MM-DD');
            o.y = zp.rechnungsbetrag;
            vals.push(o);
          }
        });
      });
      let mapToMonth = vals.map(el => ({
        ...el,
        month: parseInt(moment(el.x).format('M'))
      }));
      let monthVals = mapToMonth.reduce((acc, cur) => {
        acc[cur.month] = acc[cur.month] + cur.y || cur.y;
        return acc;
      }, {});
      let sums = Object.entries(monthVals).map(([x, y]) => ({ x, y }));
      return sums;
    },
    lz: function() {
      let vals = [];
      this.baustellen.forEach(el => {
        let beg = moment(el.beginn, 'YYYY-MM-DD').year();
        let end = moment(el.ende, 'YYYY-MM-DD').year();
        if (beg < this.year && this.year && end == this.year) {
          let b = "1";
          let e = new Date(el.ende).getMonth() + 1;
          let x = { adresse: el.adresse, zeitraum: [b, e] };
          vals.push(x);
        } else if (beg == this.year && end > this.year) {
          let b = new Date(el.ende).getMonth() + 1;
          let e = "12";
          let x = { adresse: el.adresse, zeitraum: [b, e] };
          vals.push(x);
        } else if (beg == this.year && end == this.year) {
          let b = new Date(el.beginn).getMonth() + 1;
          let e = new Date(el.ende).getMonth() + 1;
          let x = { adresse: el.adresse, zeitraum: [b, e] };
          vals.push(x);
        } else if (beg < this.year && end > this.year) {
          let b = "1";
          let e = "12";
          let x = { adresse: el.adresse, zeitraum: [b, e] };
          vals.push(x);
        }
      });
      return vals;
    },
    sumPerYear: function() {
      const sums = {
        prevprevprev: 0,
        prevprev: 0,
        prev: 0,
        current: 0,
        next: 0,
        nextplus: 0,
        nextplusplus: 0,
        nextplusplusplus: 0
      };

      this.bstPlusArchiv.forEach(el => {
        el.zahlungsplan.forEach(x => {
          const yearDifference = moment(x.datum).year() - moment().year();
          if (typeof x.rechnungsbetrag === 'number') {
            switch (yearDifference) {
              case -3:
                sums.prevprevprev += x.rechnungsbetrag;
                break;
              case -2:
                sums.prevprev += x.rechnungsbetrag;
                break;
              case -1:
                sums.prev += x.rechnungsbetrag;
                break;
              case 0:
                sums.current += x.rechnungsbetrag;
                break;
              case 1:
                sums.next += x.rechnungsbetrag;
                break;
              case 2:
                sums.nextplus += x.rechnungsbetrag;
                break;
              case 3:
                sums.nextplusplus += x.rechnungsbetrag;
                break;
              case 4:
                sums.nextplusplusplus += x.rechnungsbetrag;
                break;
            }
          }
        });
      });
      return sums;
    },
    lzAll: function() {
      let vals = [];
      this.baustellen.forEach(el => {
        let beg = moment(el.beginn)
        let end = moment(el.ende)
        let x = { adresse: el.adresse, zeitraum: [beg, end] };
        vals.push(x);
      });
      vals.sort((a, b) => { return new Date(b.zeitraum[0]) - new Date(a.zeitraum[0]) })
      return vals;
    },
    maxYear: function() {
      let years = []
      this.baustellen.forEach(el => {
        el.zahlungsplan.forEach(x => {
          if (x.datum && x.rechnungsbetrag) {
            let year = moment(x.datum).year();
            years.push(year)
          }
        })
      })
      return Math.max(...years)
    },
     minYear: function() {
      let years = []
      this.baustellen.forEach(el => {
        el.zahlungsplan.forEach(x => {
          if (x.datum && x.rechnungsbetrag) {
            let year = moment(x.datum).year();
            years.push(year)
          }
        })
      })
      return Math.min(...years)
    },
    helpYear: function() {
      let years = []
      /* let monsum = [] */
      this.baustellen.forEach(el => {
        el.zahlungsplan.forEach(x => {
          if (moment(x.datum).year() == 2020 && x.rechnungsbetrag && new Date(x.datum).getMonth() == 10) {
            let year = moment(x.datum).year();
            let adr = el.adresse
            let sum = x.rechnungsbetrag
            /* monsum.push(x.rechnungsbetrag) */
            years.push({y: year, a: adr, s: sum})
          }
        })
      })
      /* let ms = monsum.reduce(function(a, b){
        return a + b;
      }, 0); */
      return years
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      return moment(val).format("DD.MM.YYYY");
    }
  },
  methods: {
    loadMap() {
      let promises = [];
      let bla = [];
      this.baustellen.forEach(a => {
        let url =
          "https://maps.googleapis.com/maps/api/geocode/json?address=" +
          a.adresse +
          "+&key=+AIzaSyAH_7b8EuqS3NZEy1eNB_S2U_NQG7L2nxU";
        promises.push(axios.get(url));
      });
      Promise.allSettled(promises).then(results => {
        results.forEach(response => {
          if (response.value.data.results[0]) {
            let lat = response.value.data.results[0].geometry.location.lat;
            let lng = response.value.data.results[0].geometry.location.lng;
            let adr = response.value.data.results[0].formatted_address
            this.ads.push({ lat, lng, adr });
          }
        });
      })
      this.loading = false
    }
  }
};
</script>

<style scoped>
#dashboard {
  margin-top: 100px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(5, auto);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}

.div1 { grid-area: 1 / 1 / 2 / 3; }
.div2 { grid-area: 1 / 3 / 2 / 4; }
.div3 { grid-area: 2 / 1 / 3 / 4; }
.div3a { grid-area: 3 / 1 / 3 / 4; }
.div4 { grid-area: 4 / 1 / 4 / 2; }
.div5 { grid-area: 4 / 2 / 4 / 3; }
.div6 { grid-area: 4 / 3 / 4 / 4; }
.div7 { grid-area: 5 / 1 / 5 / 3; }
.div8 { grid-area: 5 / 3 / 5 / 4; }
.div9 { grid-area: 6 / 1 / 6 / 4; }

.div3, .div3a {
  min-height: 350px;
  position: relative;
}

.db-row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.dashboard-card {
  border-radius: 20px;
  padding: 20px;
  background: #eeeeee;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  margin-right: 20px;
  font-size: 12px;
}

tr {
  height: 40px;
}

.table-head {
  background: #2c3e50;
  color: #eeeeee;
  font-size: 14px;
}

.summen-table {
  table-layout: fixed;
}

td,
th {
  border-right: 1px solid rgb(212, 212, 212);
  padding: 0.5rem;
}

td:last-of-type,
th:last-of-type {
  border-right: none;
}

tr:nth-child(even) {
  background: #e3e3e4;
}

.button-col {
  text-align: center;
}

tfoot td {
  border: none;
  background: white;
  padding-left: 0;
}

h2 {
  margin-top: 0;
  margin-bottom: 10px;
}

.map-card {
  width: 100%;
}

#map {
  min-width: 100%;
  height: 100%;
}

.material-icons {
  vertical-align: middle;
  font-size: 20px;
  padding-bottom: 2px;
}

.arrow-button {
  padding: 5px;
  border-radius: 100px;
  font-size: 15px;
}

.chart {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.button-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

@media only screen and (max-width: 1000px)  {
  .dashboard-card {
    width: 90%;
  }
}

.center-button-row {
  text-align: center;
  margin-top: 20px;
}

.disabled {
  background: lightgray;
  border: 1px solid lightgray;
  cursor: auto;
}

.disabled:hover {
  color: #fff;
}

.archiv-btn {
  background: rgb(160, 160, 160);
  border: 1px solid rgb(160, 160, 160);
}

.prev-next-btns {
  margin-bottom: 10px;
}

</style>